import { useMailStore } from "../../../../stores/MailStore.js";
import { MessagesList } from "./components/MessagesList.js";
import { MailMessageListToolbar } from "../../../../components/MailMessageListToolbar.js";
import { useMessageListProvider } from "../../../hooks/useMessageListProvider.js";
import "react";
import { Loading, Pagination } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Mail/screens/MailSidebarScreen/components/MailMessageListDisplay/index.tsx
function MailMessageListDisplay({ onClickMailMessage }) {
	const { loadingMessages, mailMessages, recordsPerPage, refreshMessages, setSkippedRecords, skippedRecords, totalMessages } = useMessageListProvider();
	const folder = useMailStore((state) => state.folder);
	return /* @__PURE__ */ jsxs("div", {
		className: "relative h-full",
		children: [
			loadingMessages && /* @__PURE__ */ jsx(Loading, {
				overlay: true,
				size: "sm"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "text-color-subtle font-bold tracking-wider uppercase",
				children: folder
			}),
			/* @__PURE__ */ jsx("div", {
				className: "z-sticky bg-surface-subtle pb-xs pt-sm sticky top-0",
				children: /* @__PURE__ */ jsx(MailMessageListToolbar, {
					mailMessages,
					onActionSuccess: refreshMessages
				})
			}),
			/* @__PURE__ */ jsx(MessagesList, {
				mailMessages,
				onClickMailMessage
			}),
			/* @__PURE__ */ jsx("div", {
				className: "p-sm flex justify-center",
				children: /* @__PURE__ */ jsx(Pagination, {
					recordsPerPage,
					onPageClick: setSkippedRecords,
					showDescription: false,
					skippedRecords,
					totalRecords: totalMessages || 0
				})
			})
		]
	});
}
//#endregion
export { MailMessageListDisplay };

//# sourceMappingURL=index.js.map